<div fxLayout="column" fxLayoutGap="14px">
    <h2>Stripe</h2>
    <ng-container [ngSwitch]="status">
        <ng-container *ngSwitchCase="'disconnected'">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="32px">
                <p>Status: Disconnected</p>
                <a [href]="stripeUrl"><img src="/assets/stripe-connect.png"
                                           alt="Connect With Stripe"></a>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'unknown'">
            <p>Checking stripe status</p>
        </ng-container>
        <ng-container *ngSwitchCase="'connected'">
            <p>Status: Connected</p>
        </ng-container>
        <ng-container *ngSwitchCase="'connecting'">
            <p>Status: Connecting</p>
        </ng-container>
    </ng-container>

</div>